import { Form, Input, Radio, RadioChangeEvent, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { DetailInbound } from '../../Inbound/Interface';

function ShipmentMethodForm({
  edit,
  data
}: {
  edit?: boolean;
  data?: DetailInbound;
}) {
  const isEdit = edit ? false : true;
  const [value, setValue] = useState(
    data?.shipmentMethod ? data?.shipmentMethod : ''
  );

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };
  const defaultValue = useMemo(() => {
    return {
      shipmentDetail: data ? data?.shipmentDetail : '',
      shipmentMethod: data ? data?.shipmentMethod : ''
    };
  }, [data]);

  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue(defaultValue);
  }, [form, defaultValue]);

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ width: '100%' }}
      initialValues={{
        shipmentDetail: defaultValue.shipmentDetail,
        shipmentMethod: defaultValue.shipmentMethod
      }}
    >
      <p>Shipment Method</p>
      <div style={{ display: 'flex' }}>
        <Form.Item name="shipmentMethod">
          <Radio.Group value={value} disabled={isEdit} onChange={onChange}>
            <Space direction="vertical">
              <Radio value={'AIR'}>Air | Carrier</Radio>
              <Radio value={'Ocean'}>Ocean </Radio>
            </Space>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="shipmentDetail" rules={[{ required: true }]}>
          <Input disabled={isEdit} className="inputRadious" />
        </Form.Item>
      </div>
    </Form>
  );
}

export default ShipmentMethodForm;
